// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"05f97f40","453":"3dee37f9","455":"4d62d5fe","977":"b17e249b"}[chunkId] + ".chunk.js";
};